module.exports = __webpack_public_path__ + "img/elena&leona_parkhaus_ocular.ec8cbaff.jpg";